/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable jsx-a11y/lang */
import React, { useEffect, useState } from 'react';
import {
  Header,
  useGlobal,
  NavLink,
  Typography,
  DEFAULT_MARKET,
  globalizationPath,
  DEFAULT_LANG,
} from '@rcg/ui-react';
import { Button } from '@material-ui/core';
import { navigate } from '@gatsbyjs/reach-router/';
import { useQuery, useReactiveVar, useApolloClient } from '@apollo/client';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Link } from '@rcg/ui-react/lib/components';
import { useIdle } from 'react-use';
import { IS_LOGGED_IN, LAUNCH_DARKLY_FLAGS_AIR } from './operations/queries';
import Routes from './Routes';
import Dictionary from './utils/dictionary';
import useDictionary from './hooks/useDictionary';
import getBrand from './utils/getBrand';
import {
  HEADER_OPTIONS_PATHS,
  NAVIGATION_PATHS,
  SESSION_STORAGE_AMEND_ORIGIN,
  SESSION_STORAGE_CURRENT_BOOKING,
  SESSION_STORAGE_BOOKING_PROFILE_NAME,
  SESSION_STORAGE_BOOKING_TOKEN_NAME,
  FLIGHT_SEARCH_TYPE,
  COOKIE_KEYS,
  APPLICATION_NAME,
  ENABLE_JIRA_WIDGET,
  ENABLE_SIGN_IN_FLAG,
} from './utils/constants';
import useStyles from './index.style';
import AirFooter from './components/AirFooter';
import JiraIssueCollector from './components/Layouts';
import {
  prefixPathVar,
  globalDataVar,
  filterPanelVar,
  loyaltyDataVar,
} from './operations/localState/reactiveVariables';
import { ReactComponent as Logo } from './assets/svg/logo.svg';
import { ReactComponent as CelebrityLogo } from './assets/svg/celebrity-cruises-logo-x-white.svg';
import { getCookies, signOffProfile, appendGlobalizationToPath } from './utils/common';
import royalAppdynamics from './utils/royalAppdynamics';
import celAppdynamics from './utils/celAppdynamics';
import { LDUser } from './utils/ldUser';

// eslint-disable-next-line consistent-return
const App = () => {
  const {
    loading,
    error,
    data: { market, country, lang, currency, isoCode },
  } = useGlobal();

  const searchParams = new URLSearchParams(window.location.search);

  // params defined for deeplink on browse path
  const shipCode = searchParams.get('shipCode');
  const sailDate = searchParams.get('date');

  // params defined for deeplink with booking reservation
  const bookingId = searchParams.get('bookingId');
  const lastName = searchParams.get('lastName');
  const urlToken = searchParams.get('token');

  const classes = useStyles();
  const getDictionary = useDictionary(Dictionary);
  const client = useApolloClient();
  const [hideMenuOptions, setHideMenuOptions] = useState(true);
  const [profileName, setProfileName] = useState();

  const { loading: loginLoading, error: loginError, data: loginData } = useQuery(IS_LOGGED_IN);
  const filterPanel = useReactiveVar(filterPanelVar);
  const isAmendOrigin = sessionStorage.getItem(SESSION_STORAGE_AMEND_ORIGIN) || false;
  const showHeaderOptions = HEADER_OPTIONS_PATHS.some((path) =>
    window.location.pathname.includes(path),
  );
  const backToAmend = loginData?.isLoggedIn && isAmendOrigin;
  const prefixPath = market === DEFAULT_MARKET && lang === DEFAULT_LANG ? '' : `/${market}/${lang}`;
  const isIdle = useIdle(1.8e6); // 30 minutes track user inactivity
  const isCelebrity = getBrand().id === 'cel';

  const flagsVariables = {
    ldUser: LDUser(),
    language: lang,
    clientApp: APPLICATION_NAME,
    application: APPLICATION_NAME,
    brand: getBrand()?.ldBrand,
  };
  const { data: initialFlags } = useQuery(LAUNCH_DARKLY_FLAGS_AIR, {
    fetchPolicy: 'no-cache',
    variables: flagsVariables,
  });

  useEffect(() => {
    if (!showHeaderOptions) {
      setHideMenuOptions(true);
    } else setHideMenuOptions(false);
  }, [showHeaderOptions]);

  const getUserProfileName = (loyaltyData) => {
    const parts = loyaltyData?.split('|');
    const name = parts?.[0].split('=');
    return name?.[1];
  };

  const signOut = async () => {
    signOffProfile(client);
    if (backToAmend) {
      window.location.replace(`${prefixPath}${NAVIGATION_PATHS.reservation}`);
    } else {
      window.location.replace(
        `${prefixPath}${NAVIGATION_PATHS.base}${NAVIGATION_PATHS.bookFlights}`,
      );
      setProfileName(null);
      loyaltyDataVar(null);
    }
  };

  const loyaltyData = useReactiveVar(loyaltyDataVar) || getCookies(COOKIE_KEYS.LOYALTY_DATA);

  useEffect(() => {
    const name = loyaltyData && getUserProfileName(loyaltyData);
    setProfileName(name);
  }, [loyaltyData]);

  useEffect(async () => {
    const loadScript = (src) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
      return script;
    };

    loadScript(process.env.REACT_APP_APPDYNAMICS_URL);

    if (isCelebrity) {
      celAppdynamics();
      loadScript(process.env.REACT_APP_TEALIUM_URI_CEL);
    } else {
      royalAppdynamics();
      loadScript(process.env.REACT_APP_TEALIUM_URI);
    }
  }, []);

  useEffect(() => {
    if (isIdle) {
      signOut();
    }
  }, [isIdle]);

  if (loading || loginLoading) return <p />;

  if (error || loginError) return <p>Error</p>;
  if (market && lang && loginData) {
    prefixPathVar(prefixPath);
    globalDataVar({ country, currency, language: lang });

    const baseUrlPath = globalizationPath(market, lang, NAVIGATION_PATHS.base);
    const manageUrlPath = `${baseUrlPath}${NAVIGATION_PATHS.manage}`;
    const bookFlightUrlPath = `${baseUrlPath}${NAVIGATION_PATHS.bookFlights}`;
    const paymentUrlPath = `${baseUrlPath}${NAVIGATION_PATHS.payment}`;
    const isBrowseUrl = window.location.pathname.includes(NAVIGATION_PATHS.browse);
    const isPaymentUrl = window.location.pathname.startsWith(paymentUrlPath);
    const isManagePage = window.location.pathname.includes(NAVIGATION_PATHS.manage);
    const isResultsDeparture = window.location.pathname.includes(NAVIGATION_PATHS.resultsDeparture);
    const isResultsPage =
      window.location.pathname.includes(FLIGHT_SEARCH_TYPE.DEPARTURE) ||
      window.location.pathname.includes(FLIGHT_SEARCH_TYPE.RETURN);

    // It returns an array of all existing routes on navigation paths with the globalizacion path market/lang
    const validPaths = [
      baseUrlPath,
      ...Object.values(NAVIGATION_PATHS).map((value) => baseUrlPath + value),
    ];

    const isAValidPath = validPaths.includes(window.location.pathname);
    const accessToken = getCookies(COOKIE_KEYS.ACCESS_TOKEN);
    const isBrowseDeepLink = Boolean(isBrowseUrl && shipCode && sailDate);
    const isBookingDeepLink = Boolean(
      isResultsDeparture && shipCode && sailDate && lastName && bookingId,
    );

    const allowNavigation =
      isBrowseUrl ||
      isManagePage ||
      accessToken ||
      isBrowseDeepLink ||
      isBookingDeepLink ||
      isResultsDeparture ||
      urlToken;

    const allowedMarkets = ['usa', 'gbr', 'aus'];

    // To handle app navigation
    if (!loginData.isLoggedIn) {
      const currentPath = window.location.pathname;
      if (!isAValidPath) {
        if (allowedMarkets.includes(market) && allowNavigation) {
          // remove country/lang from url
          const pathParts = currentPath.split('/');
          const newPath = pathParts.length >= 3 ? `/${pathParts.slice(3).join('/')}` : '';

          // generate new url adding globalizacion based on market
          const newGlobalPath = globalizationPath(market, lang, newPath);
          const queryParams = document.location.search;
          navigate(newGlobalPath + (searchParams.size > 0 ? `${queryParams}` : ''));
        } else {
          navigate(bookFlightUrlPath);
        }
      }
    } else if (!isAValidPath) {
      navigate(manageUrlPath);
    }

    const isReviewFlight = window.location.pathname.includes('review-flight');
    const rederDefaultFooter = !isPaymentUrl && !isReviewFlight;

    const redirectToLookUp = () => {
      if (backToAmend) {
        sessionStorage.removeItem(SESSION_STORAGE_CURRENT_BOOKING);
        sessionStorage.removeItem(SESSION_STORAGE_BOOKING_PROFILE_NAME);
        sessionStorage.removeItem(SESSION_STORAGE_BOOKING_TOKEN_NAME);
      }
    };

    const handleRedirections = () => {
      if (!backToAmend) {
        client.writeQuery({ query: IS_LOGGED_IN, data: { isLoggedIn: false } });
      }
      redirectToLookUp();
    };

    const isSigninEnabled = initialFlags?.ldFlags[ENABLE_SIGN_IN_FLAG];
    const isAvaiblableJiraWidget = initialFlags?.ldFlags[ENABLE_JIRA_WIDGET];

    const logoHrefUrl = appendGlobalizationToPath('/', { market, lang, isoCode, country });
    return (
      <div className="main-container">
        <Header
          position="sticky"
          elevation={0}
          className={`${classes.headerContainer} ${isCelebrity ? 'cel' : 'rcl'} ${
            isResultsPage ? '' : 'stretch'
          }`}>
          <>
            <a href={logoHrefUrl}>
              {isCelebrity ? <CelebrityLogo /> : <Logo className={classes.logo} />}
            </a>
            {isSigninEnabled && profileName && (
              <div className={classes.signOut}>
                <Link className="greetingLink" href={NAVIGATION_PATHS.guestAccount}>
                  <span className="greetingHeader" data-cs-mask>
                    {profileName &&
                      `${getDictionary(
                        Dictionary.headerBookingAmendGreeting.key,
                      )}, ${profileName} `}
                    <span className="blankSpaceSpan">|</span>
                  </span>
                </Link>
                <Button variant="text" onClick={signOut}>
                  <span className="exit-label">
                    {getDictionary(Dictionary.headerBookingAmendSignOut.key)}
                  </span>
                  <ExitToAppIcon className="exit-icon" />
                </Button>
              </div>
            )}
            {!profileName && !hideMenuOptions && (
              <NavLink
                onClick={handleRedirections}
                component="a"
                icon=""
                href={
                  backToAmend
                    ? `${prefixPath}${NAVIGATION_PATHS.reservation}`
                    : `${prefixPath}${NAVIGATION_PATHS.base}${NAVIGATION_PATHS.bookFlights}`
                }>
                <Typography variant="body2" className="headerTypography">
                  {getDictionary(Dictionary.airHeaderExitReservation.key)}
                </Typography>
              </NavLink>
            )}
          </>
        </Header>
        <Routes urlPath={baseUrlPath} />
        {isAvaiblableJiraWidget && <JiraIssueCollector />}
        {rederDefaultFooter && (
          <AirFooter
            className={`${filterPanel?.isOpen ? classes.footerToRight : ''} ${
              isResultsPage ? '' : classes.stretch
            } `}
          />
        )}
      </div>
    );
  }
};

export default App;
